import { render, staticRenderFns } from "./ReorderButton.vue?vue&type=template&id=296215e4&scoped=true&"
import script from "./ReorderButton.vue?vue&type=script&lang=js&"
export * from "./ReorderButton.vue?vue&type=script&lang=js&"
import style0 from "./ReorderButton.vue?vue&type=style&index=0&id=296215e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296215e4",
  null
  
)

export default component.exports